module.exports = __webpack_public_path__ + "8d6eafeb7499755406e8f522b23cec74.fbx";